// Nacharbeit B (Nutzer 1.10.2026): "Beim Finanzamt abmelden" = endgueltige
// (planmaessige) Ausserbetriebnahme der Registrierkasse.
//   RKSV § 17 Abs. 8: Schlussbeleg mit Betrag Null erstellen, ausdrucken,
//   aufbewahren (§ 9 Abs. 1: signiert). § 17 Abs. 1: Ausserbetriebnahme ueber
//   FinanzOnline melden - ausfall_kasse/ausserbetriebnahme, Grund 6
//   (BMF-Webservice-Spezifikation S. 5/6 und 4.3; tools/RKSV-ONLINE-SIGNATUR.md 12.11).
// Ablauf: Schlussbeleg SCH als LETZTER Beleg der Kette ueber die
// Belegwarteschlange (receiptprinter inBelegReihe, nach faelligen
// MVC/JVC/AZR/SZR). Der Kassenserver sperrt die Kasse mit der geprueften
// Signatur des Schlussbelegs (keine Signatur mehr, auch kein Ausfall). Dann
// belegpruefung des Schlussbelegs und die Meldung ueber Kassenserver ->
// Zentrale; was scheitert, wiederholt die Zentrale (Ereignis kasse_ausser_betrieb).
// Nur jQuery-Deferreds (tools/MODERNISIERUNG.md Regel 4).
import { inBelegReihe } from '../domain/bon/receiptprinter.js';

// maxMs: nach dieser Zeit bekommt die Oberflaeche ein Ergebnis (Zeitlimit) -
// die Belegwarteschlange bleibt aber belegt, bis der Weg WIRKLICH zu Ende ist
// (Fix-Runde 1, Important 1). Ueber window fuer Suite/Diagnose einstellbar.
var einstellungen = { maxMs: 60000 };
// Fix-Runde 2: der Schlussbeleg dieser Sitzung wird gerade signiert/gespeichert.
var schLaeuft = false;
window.schlussbelegEinstellungen = einstellungen;

// Payload-Felder einer kompakten JWS (13 Felder, Feld 0 leer) oder null.
function payloadFelder(jws) {
    try {
        var p = String(jws).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        while (p.length % 4) p += "=";
        var felder = atob(p).split("_");
        return felder.length === 13 && felder[0] === "" ? felder : null;
    } catch (e) {
        return null;
    }
}

// Liefert {ok:true, qr, receiptID} oder {ok:false, grund, phase, zeitlimit}.
// phase: 'vor' (Schlussbeleg noch nicht begonnen) | 'sch' (Signatur/Speichern/
// Druck des Schlussbelegs lief). Nie ein Beleg mit Ausfall-Vermerk. Nach einem
// Zeitlimit in Phase 'vor' wird der Schlussbeleg NICHT mehr begonnen; die
// Warteschlange gibt erst frei, wenn der Weg wirklich beendet ist (sonst
// koennte ein spaeter gespeicherter SCH die Kette verzweigen).
function schlussbelegErstellen() {
    var dfd = jQuery.Deferred();
    inBelegReihe(function (freigeben) {
        var phase = "vor", gemeldet = false, frei = false;
        var freigabe = function () { if (!frei) { frei = true; freigeben(); } };
        var melde = function (erg) {
            if (gemeldet) return;
            gemeldet = true;
            clearTimeout(uhr);
            dfd.resolve(erg);
        };
        var uhr = setTimeout(function () {
            log.add(1, "Error", "RKSV", "Schlussbeleg nach " + (einstellungen.maxMs / 1000) + " s nicht fertig (Phase " + phase + ")");
            melde({ ok: false, grund: "Zeitlimit", zeitlimit: true, phase: phase });
        }, einstellungen.maxMs);
        var abbruch = function (grund) { return function () { freigabe(); melde({ ok: false, grund: grund, phase: phase }); }; };
        $.when(POS.SQLiteCon.lastInsertBonRegId()).done(function (ID) {
            var Receipt = new CReceipt(parseInt(ID) + 1);
            $.when(Receipt.defreturn).done(function () {
                // Faellige Monats-/Jahres-/Sammelbelege (und ein Signaturwechsel)
                // kommen VOR den Schlussbeleg - er ist der letzte Beleg der Kette.
                $.when(Receipt.checkPrevReceipt()).then(function () {
                    if (gemeldet) {
                        // Zeitlimit schon gemeldet ("nicht abgemeldet"): sauber abbrechen.
                        log.add(1, "Error", "RKSV", "Schlussbeleg nach Zeitlimit nicht mehr begonnen");
                        return freigabe();
                    }
                    phase = "sch";
                    schLaeuft = true;
                    var receiptID = parseInt(Receipt.receiptIdentifier);
                    Receipt.insertZeroSentence('SCH', Receipt.datestr, true, function (qr) {
                        schLaeuft = false;
                        freigabe();
                        if (!qr) return melde({ ok: false, grund: "nicht signiert oder nicht gespeichert", phase: "sch" });
                        log.add(2, "Info", "RKSV", "Schlussbeleg " + receiptID + " signiert und gespeichert");
                        melde({ ok: true, qr: qr, receiptID: receiptID });
                    });
                }, abbruch("Vorbelege"));
            }).fail(abbruch("Beleg"));
        }).fail(abbruch("Belegnummer"));
    });
    return dfd.promise();
}

// Fix-Runde 1 (Important 2): Ist die Kasse gesperrt, MUSS der signierte
// Schlussbeleg der letzte Beleg in BONREG sein - samt BON-Zeile SCH und
// Druck. Fehlt er (Antwort verloren, Speichern gescheitert, Neuladen), wird er
// aus der beim Kassenserver gespeicherten kompakten JWS nachgetragen und
// gedruckt - nur wenn Belegnummer und Verkettung zum letzten Beleg passen;
// sonst nichts schreiben (Support). Fehlt nur die BON-Zeile (Fix-Runde 2),
// wird sie ergaenzt und der Beleg gedruckt.
// Laeuft in der Belegwarteschlange. Liefert {status: 'offen' (nicht gesperrt) |
// 'vorhanden' | 'nachgetragen' | 'fehler' | 'unklar' (Zustand nicht lesbar
// bzw. eigener Schlussbeleg noch in Arbeit), receiptID, qr, grund}.
// Jeder Fehlerzweig beendet den Auftrag sofort (kein Warten auf das 90-s-Netz).
function schlussbelegSichern() {
    var dfd = jQuery.Deferred();
    inBelegReihe(function (freigeben) {
        var fertig = false;
        var ende = function (erg) {
            if (fertig) return;
            fertig = true;
            if (erg.status === "fehler" || erg.status === "unklar") log.add(1, "Error", "RKSV", "Schlussbeleg sichern: " + erg.status + " - " + erg.grund);
            freigeben();
            dfd.resolve(erg);
        };
        var fehler = function (grund, basis) { return function () { ende($.extend({ status: "fehler", grund: grund }, basis || {})); }; };
        // Der eigene Schlussbeleg dieser Sitzung wird noch gespeichert (z.B. nach
        // dem 90-s-Netz der Warteschlange): nie parallel nachtragen.
        if (schLaeuft) return ende({ status: "unklar", grund: "Schlussbeleg wird noch gespeichert" });
        $.when(POS.Smartcard.init(false, true)).then(function () {
            if (POS.Smartcard.zustandFehler) return ende({ status: "unklar", grund: "Kassenserver-Zustand nicht lesbar" });
            var sb = POS.Smartcard.ausserBetrieb;
            if (!sb) return ende({ status: "offen" });
            var felder = sb.jws ? payloadFelder(sb.jws) : null;
            if (!felder) return ende({ status: "fehler", grund: "Schlussbeleg beim Kassenserver nicht lesbar" });
            var nr = parseInt(felder[3]);
            var basis = { receiptID: nr, qr: sb.qr };
            // BON-Zeile SCH (nach der Sperre angelegt) ergaenzen und drucken.
            var bonZeileUndDruck = function (r, status) {
                $.when(new CBonManager().addEntryMVC('SCH')).then(function () {
                    try { fs.unlinkSync('/tmp/whichbon.sql'); } catch (e) { /* gibt es meist nicht */ }
                    r.printNullBon("SELECT * from BONREG where BON_ID=0 order by ReceiptId desc limit 1", "SCHLUSSBELEG", false, null);
                    log.add(1, "Warning", "RKSV", "Schlussbeleg " + nr + " vervollstaendigt (BON-Zeile, Druck)");
                    ende($.extend({ status: status }, basis));
                }, fehler("BON-Zeile SCH nicht gespeichert", basis));
            };
            $.when(new CReceiptTransaction().readDBtoReceiptLastRecord()).done(function (letzter) {
                if (letzter && String(letzter.jwsCompactRepresentation) === sb.jws) {
                    var seit = Math.floor(Number(sb.seit) / 1000) - 1;
                    return $.when(POS.SQLiteCon.execute("SELECT COUNT(*) AS n FROM BON WHERE Type = 'SCH' AND End >= " + (seit > 0 ? seit : 0))).then(function (rows) {
                        if (rows && rows[0] && Number(rows[0].n) > 0) return ende($.extend({ status: "vorhanden" }, basis));
                        bonZeileUndDruck(letzter, "nachgetragen");
                    }, fehler("BON-Zeilen nicht lesbar", basis));
                }
                if (!letzter || parseInt(letzter.receiptIdentifier) !== nr - 1)
                    return ende($.extend({ status: "fehler", grund: "Belegnummer " + nr + " passt nicht zum letzten Beleg " + (letzter && letzter.receiptIdentifier) }, basis));
                var probe = new CReceipt();
                probe.PreviousReceipt = letzter;
                if (probe.sigPrevReceipt(false) !== felder[12])
                    return ende($.extend({ status: "fehler", grund: "Verkettung des Schlussbelegs passt nicht zum letzten Beleg" }, basis));
                var r = new CReceipt();
                var betrag = function (b) { return String(b).replace(",", "."); };
                r.setParameters(nr, felder[4], betrag(felder[5]), betrag(felder[6]), betrag(felder[7]), betrag(felder[8]), betrag(felder[9]),
                    felder[10], felder[11], felder[12], sb.jws);
                r.BonID = 0;
                $.when(new CReceiptTransaction().insertBon(r)).then(function () {
                    window.PreviousReceipt = r;
                    $.when(POS.SQLiteCon.lastInsertBonRegId()).done(function (ID) {
                        if (parseInt(ID) !== nr) log.add(1, "Error", "RKSV", "Schlussbeleg nachgetragen als " + ID + " statt " + nr + " - bitte pruefen");
                        log.add(1, "Warning", "RKSV", "Schlussbeleg " + nr + " aus dem Kassenserver nachgetragen");
                        bonZeileUndDruck(r, "nachgetragen");
                    }).fail(fehler("Belegnummer nach dem Nachtragen nicht lesbar", basis));
                }, fehler("Speichern in BONREG gescheitert", basis));
            }).fail(fehler("letzter Beleg nicht lesbar", basis));
        }, function () { ende({ status: "unklar", grund: "Kassenserver-Zustand nicht lesbar" }); });
    });
    return dfd.promise();
}

// Erst die Belegpruefung des Schlussbelegs, dann die Ausserbetriebnahme -
// beide ueber Kassenserver -> Zentrale. Die Meldung folgt auch, wenn die
// Pruefung scheitert (gesetzlich ist nur die Meldung verlangt).
function schlussbelegMelden(qr) {
    var dfd = jQuery.Deferred();
    var ws = new CWebservice();
    ws.startWebservice('schlussbelegpruefung', function (pruefung) {
        ws.startWebservice('ausserbetriebnahme_kasse', function (meldung) {
            dfd.resolve({ pruefung: !!pruefung, meldung: !!meldung });
        });
    }, qr);
    return dfd.promise();
}

export { schlussbelegErstellen, schlussbelegSichern, schlussbelegMelden };
